import VersionInterceptor from "@/api/VersionInterceptor";
import { IPartnerInfo, Logger, PartnerTier } from "@iloq/shared";
import axioslib, { AxiosInstance, AxiosRequestConfig } from "axios";
import { AuthInterceptor } from "./AuthInterceptor";

export default class PartnerInfoApi {
  private readonly axios: AxiosInstance;

  constructor() {
    this.axios = axioslib.create();
    AuthInterceptor.setAuthInterceptors(this.axios);
    VersionInterceptor.setVersionInterceptor(this.axios);
  }

  getPartnerInfo(email: string): Promise<IPartnerInfo> {
    const options: AxiosRequestConfig = {
      method: "GET",
      url: `/api/v1/partner/partnerinfo/${email}`,
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("PartnerInfoApi.getPartnerinfo failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        // Easiest way to test different tiers
        // result.data.partnerTier = PartnerTier.GOLD;
        return result.data as IPartnerInfo;
      });
  }
}
